import slice from './slice.clipart';
import * as clipArtTypes from './types.clipart';

export const { reducer: clipArtState, actions: clipArtActions } = slice;
export { clipArtTypes };
export { default as clipArtSaga } from './saga.clipart';
export { default as clipArtSelector } from './selector.clipart';
export default slice;
